import { render, staticRenderFns } from "./SpacerField.vue?vue&type=template&id=0a412bc3&scoped=true"
import script from "./SpacerField.vue?vue&type=script&lang=js"
export * from "./SpacerField.vue?vue&type=script&lang=js"
import style0 from "./SpacerField.vue?vue&type=style&index=0&id=0a412bc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a412bc3",
  null
  
)

export default component.exports